import { NodeType } from "../Models/NodeType";
import { usePipelineBuilder } from "V2.0/HomePages/Pipelines/PipelineBuilder/PipelineBuilderProvider";

import WebhookTriggerConfig from "./WebhookTrigger";
import { useReactFlow } from "@xyflow/react";
import AssistantConfig from "./Assistant";
import ConditionalConfig from "./Conditional";
import ExternalApiConfig from "./ExternalApi";
import EndConfig from "./End";
import WaitForCallbackConfig from "./WaitForCallback";
import DelayNodeConfig from "./Delay";

export default NodeConfigure;

const NodeConfigureRegistry = {
  [NodeType.WEBHOOK_TRIGGER]: WebhookTriggerConfig,
  [NodeType.ASSISTANT]: AssistantConfig,
  [NodeType.CONDITIONAL]: ConditionalConfig,
  [NodeType.EXTERNAL_API]: ExternalApiConfig,
  [NodeType.END]: EndConfig,
  [NodeType.WAIT_FOR_CALLBACK]: WaitForCallbackConfig,
  [NodeType.DELAY]: DelayNodeConfig
};

function NodeConfigure() {
  const { updateNode } = useReactFlow();
  const { panel, closePanel, workspaceId, evolutionConfiguration, assistants, getActiveWhatsappProvider } = usePipelineBuilder();
  const sourceNode = panel.sourceNode;

  const Configure = NodeConfigureRegistry[sourceNode.type];

  return (
    <Configure
      workspaceId={workspaceId}
      node={sourceNode}
      closePanel={closePanel}
      onSave={(nodeId, data) => {
        updateNode(nodeId, { data });
      }}
      assistants={assistants}
      validationErrors={panel.validationErrors}
      evolutionConfiguration={evolutionConfiguration}
      getActiveWhatsappProvider={getActiveWhatsappProvider}
    />
  );
}
